import React, { Component } from 'react';

export default class Services extends Component {
  render() {
    const services = [
      {
        icon: '🔐',
        title: 'Identity & Access Systems',
        description:
          'End-to-end design and implementation of identity providers, authentication flows, and fine-grained authorization systems. I\'ve shipped this twice across fintech and asset management -- from federated S3 access control to a full Cognito-based IdP supporting external users, internal applications, and machine-to-machine auth.',
        tags: ['Cognito', 'IAM', 'JWT', 'OAuth', 'DynamoDB', 'FastAPI'],
        anchor: 'Two shipped projects across two industries',
      },
      {
        icon: '☁️',
        title: 'AWS Cost Optimization & Architecture',
        description:
          'AWS cost audits, right-sizing, and infrastructure modernization. Conducted an AWS cost audit for DocuGuardian that reduced monthly cloud spend by ~30%. AWS expertise runs through every role I\'ve held -- from building serverless data platforms at Discover to deploying multi-account infrastructure with Terraform.',
        tags: ['Lambda', 'Terraform', 'API Gateway', 'CloudWatch', 'S3', 'Cost Optimization'],
        anchor: 'Proven results across startups and enterprise',
      },
      {
        icon: '🤖',
        title: 'AI Integration & Application Development',
        description:
          'Helping teams ship AI applications that actually get used. Led an AI Engineering team at Harbor Capital to research, build, and deploy tools that automate real business workflows -- not demos. From RAG pipelines to full-stack AI-powered apps, I bridge the gap between model capabilities and production software.',
        tags: ['AWS Bedrock', 'RAG', 'OpenSearch', 'Python', 'React', 'FastAPI'],
        anchor: 'Led AI Engineering team in production',
      },
    ];

    return (
      <section id="services">
        <style>{`
          #services {
            padding: 60px 0;
            border-top: 1px solid #e8e8e8;
          }

          #services .section-header {
            margin-bottom: 48px;
          }

          #services .section-header h1 span {
            font: var(--header-font, 13px/24px 'opensans-semibold', sans-serif);
            letter-spacing: 2px;
            text-transform: uppercase;
            color: #6E7881;
          }

          .service-card {
            background: #fff;
            border: 1px solid #e8e8e8;
            border-top: 3px solid #11ABB0;
            padding: 32px 28px;
            margin-bottom: 24px;
            transition: box-shadow 0.2s ease, transform 0.2s ease;
          }

          .service-card:hover {
            box-shadow: 0 6px 24px rgba(0,0,0,0.08);
            transform: translateY(-2px);
          }

          .service-card .service-icon {
            font-size: 28px;
            margin-bottom: 14px;
            display: block;
          }

          .service-card h3 {
            font-family: 'opensans-bold', sans-serif;
            font-size: 17px;
            color: #313131;
            margin-bottom: 10px;
            letter-spacing: 0;
          }

          .service-card p {
            font-size: 14px;
            line-height: 1.75;
            color: #6E7881;
            margin-bottom: 18px;
          }

          .service-card .anchor-line {
            font-size: 12px;
            font-family: 'opensans-semibold', sans-serif;
            color: #11ABB0;
            letter-spacing: 0.5px;
            margin-bottom: 16px;
            display: block;
          }

          .service-card .tags {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
          }

          .service-card .tag {
            background: #f4f4f4;
            color: #6E7881;
            font-size: 11px;
            padding: 4px 10px;
            border-radius: 2px;
            font-family: 'opensans-semibold', sans-serif;
            letter-spacing: 0.3px;
          }

          .services-cta {
            margin-top: 16px;
            padding-top: 32px;
            border-top: 1px solid #e8e8e8;
            text-align: center;
          }

          .services-cta p {
            color: #6E7881;
            font-size: 15px;
            margin-bottom: 16px;
          }

          .services-cta a {
            display: inline-block;
            background: #11ABB0;
            color: #fff;
            padding: 12px 28px;
            font-family: 'opensans-semibold', sans-serif;
            font-size: 13px;
            letter-spacing: 1px;
            text-transform: uppercase;
            text-decoration: none;
            transition: background 0.2s ease;
          }

          .services-cta a:hover {
            background: #0d8f93;
          }
        `}</style>

        <div className="row">
          <div className="three columns header-col section-header">
            <h1><span>Services</span></h1>
          </div>

          <div className="nine columns main-col">
            {services.map((service, index) => (
              <div className="service-card" key={index}>
                <span className="service-icon">{service.icon}</span>
                <h3>{service.title}</h3>
                <span className="anchor-line">&#8627; {service.anchor}</span>
                <p>{service.description}</p>
                <div className="tags">
                  {service.tags.map((tag, i) => (
                    <span className="tag" key={i}>{tag}</span>
                  ))}
                </div>
              </div>
            ))}

            <div className="services-cta">
              <p>Have a project in mind? Let's talk through it.</p>
              <a href="mailto:jonahmurraydev@gmail.com">Get In Touch</a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}